module.exports = __webpack_public_path__ + "img/icon-institution.644af947.svg";